var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopyTrade = function SvgCopyTrade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.31 10.123a3.803 3.803 0 1 1 0 7.605 3.803 3.803 0 0 1 0-7.605M17.5 12.688v4.973h-2.485v-.002h-3.349v-2.484h3.349v-2.488zM4.819 13.926l1.49 1.49 1.49-1.49-1.49-1.49zm10.724-6.44c1.065 0 1.928.919 1.928 2.052v1.55h-6.45v-1.55c0-1.133.863-2.052 1.928-2.052zm-5.295-2.323H4.983v3.092H2.5V2.68h7.748zm3.998-2.89a2.038 2.038 0 1 1 0 4.077 2.038 2.038 0 0 1 0-4.077"
  })));
};
export default SvgCopyTrade;